export enum EntityType {
  'PATIENT' = 'PATIENT',
  'DOCTOR' = 'DOCTOR',
  'FACILITY' = 'FACILITY',
  'CLIENT' = 'CLIENT',
  'PHARMACY' = 'PHARMACY',
  'PHARMACY_GROUP' = 'PHARMACY_GROUP',
}
